import ArticleCard from '@/common/interfaces/modules/ArticleCard';
import { ItineraryCard } from '@/components/ItineraryCard/ItineraryCard.types';
import LinkItem from '@/common/interfaces/LinkItem';
import {
  FilterableGridViewModel,
  IGridCard,
} from '@/modules/FilterableGridModule/FilterableGridModule.types';

export interface RelatedItemsModuleViewModel {
  Title?: string;
  TitleSmall?: string;
  // We need a way to define category that gets passed for a layout perspective on the front-end. Will explain further at a later date
  Category?: string;
  Link?: LinkItem;
  Items: Array<ItineraryCard | ArticleCard | any>;
  IsGrid?: boolean;
  ViewMoreText?: string;
}

export function convertToGridConfig(data: RelatedItemsModuleViewModel): FilterableGridViewModel {
  return {
    Cards: data.Items as IGridCard[],
    Paging: {
      Total: data.Items.length,
      PageSize: 12,
      PageSizeMedium: 8,
      PageSizeSmall: 4,
      ViewCounts: false,
      LoadMoreButton: {
        Title: data.ViewMoreText || 'View more Itineraries',
        Link: '#',
      },
    },
    AppliedFilters: null
  };
}
